import { Model } from "./model";
import { ObjectMapper } from "json-object-mapper";
import { IModel } from "./IModel";

export class EmployeeFeedbackModel extends Model implements IModel<EmployeeFeedbackModel> {
  startDoing: string = "";
  keepDoing: string = "";
  stopDoing: string = "";
  showToEmployee: boolean = false;
  employeeId: string | undefined = undefined;
  employeeName: string = "";
  employeeRegistration: string = "";
  competenceId: string | undefined = undefined;
  competenceTitle: string = "";
  employeeManagerId: string | undefined = undefined;
  employeeManagerName: string = ""; 
  employeeJobTitle: string = "";
  creationDate: string = "";
  employeeStatus: string = "";
  statusLabel: string = "";
  employeeManagerJobTitle: string = '';
  costCenterName: string = "";
  costCenterArea: string = "";

  static create(input: any): EmployeeFeedbackModel {
    return ObjectMapper.deserialize<EmployeeFeedbackModel>(EmployeeFeedbackModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}